import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c2081a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mydiv",
  class: "w-100 h-100"
}
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_4 = { class: "adminListDiv0" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div style=\"width:100%;\" data-v-0c2081a5><table id=\"tblAdminList\" style=\"width:calc(100% - 16px);\" data-v-0c2081a5><thead data-v-0c2081a5><tr data-v-0c2081a5><th style=\"width:8%;\" data-v-0c2081a5>User ID</th><th style=\"width:20%;\" data-v-0c2081a5>Given Name</th><th style=\"width:20%;\" data-v-0c2081a5>Family Name</th><th style=\"width:7%;\" data-v-0c2081a5>Station Code</th><th style=\"width:25%;\" data-v-0c2081a5>Company Name</th><th style=\"width:21%;\" data-v-0c2081a5>Email</th></tr></thead></table></div>", 1)
const _hoisted_6 = {
  key: 1,
  style: {"text-align":"center","height":"calc(96% - 200px)"}
}
const _hoisted_7 = {
  key: 2,
  id: "tblAdminBodyDiv",
  style: {"height":"calc(98.5% - 200px)","overflow":"auto"}
}
const _hoisted_8 = { id: "tblAdminList" }
const _hoisted_9 = { id: "tbltbody" }
const _hoisted_10 = { style: {"width":"8%"} }
const _hoisted_11 = { style: {"width":"20%"} }
const _hoisted_12 = { style: {"width":"20%"} }
const _hoisted_13 = { style: {"width":"7%"} }
const _hoisted_14 = { style: {"width":"25%"} }
const _hoisted_15 = { style: {"text-align":"center","width":"21%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isLoading == true)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        style: {"cursor":"pointer","color":"blue","text-decoration":"underline"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.addAdminUser()))
      }, "Add new admin user")
    ]),
    _hoisted_5,
    ($setup.distAdminListInfo.length == 0 && $setup.getData)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_6, " No data "))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.distAdminListInfo[0], (info, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(info.userId), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(info.givenName), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(info.familyName), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(info.stationcode), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(info.companyName), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(info.email), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]))
  ]))
}